import { Component, Input, OnInit, OnChanges, SimpleChange, ViewChild, ElementRef, HostListener, Output, EventEmitter} from '@angular/core';
import { Chart, ChartConfiguration, ChartOptions } from 'chart.js';
import { LineProfile } from './chart';
import { BaseChartDirective } from "ng2-charts";
import { clean as CleanDataset, build as BuildDataset  } from './chart.helper';
import { ChartOptionsConfig, Axes, getOptionConfig } from './chart.config';

/**
 * here we can create custom style for line.
 */
type OnClickCallback = (event: any, p1 :any, p2:any) => any;


@Component({
  selector: 'app-chart',
  templateUrl: './chart.component.html',
  styleUrls: ['./chart.component.scss']
})
export class ChartComponent implements OnInit, OnChanges {
  
  @Input() dataset:null | any = null;
  @Input() profile: string | null = null;
  @Input() label: any = null;
  @Input() legendOnClick: OnClickCallback | undefined;
  @Input('enable-save-button') enableSaveBtn: boolean = false;

  @ViewChild(BaseChartDirective) chart: BaseChartDirective| null = null; 
  @ViewChild('chartElem') canvas: ElementRef;

  @Output('onSave') onSave: EventEmitter<any> = new EventEmitter();

  _dataset : null | any = null;

  public lineChartData: ChartConfiguration<'line'>['data'] = {
    labels:Axes,
    datasets: []
  };
  public lineChartOptions: ChartOptions<'line'> | undefined;
  public lineChartLegend = true;

  constructor() {
   
  }

  ngOnInit(): void {
    this.lineChartOptions = getOptionConfig();
    this.addPlugin();
    this.attachLegendOnClick();
  }
  attachLegendOnClick(){
    if(this.lineChartOptions?.plugins){
      this.lineChartOptions.plugins = {
        ... this.lineChartOptions.plugins
      };
      if(typeof this.legendOnClick == 'function' && this.lineChartOptions?.plugins?.legend){
        this.lineChartOptions.plugins.legend = {
          onClick : this.legendOnClick,
          ...this.lineChartOptions.plugins.legend
        };
      }
    }
  }
  ngOnChanges({dataset}: { dataset:SimpleChange }): void{
    if(dataset){
           let { currentValue: _dataset } = dataset;
           this._dataset = CleanDataset(_dataset);
           this.rebuildLineChartDataset();
    }
  }

  rebuildLineChartDataset() :void {
   
      this.lineChartData.datasets =[...BuildDataset(this._dataset, this.profile)]; 
      if(this.chart){
        this.chart?.chart?.update();
      } 
  }

  saveCanvas(){
    this?.onSave?.emit();
  }

  /**
   * Applying chart js plugin
   */
  addPlugin() :void {
    
    /**
     * Overriding some chart ooptions here
     */
    Chart.defaults.color = '#000';
    Chart.defaults.backgroundColor = '#fff';

    // Fill white

    Chart.register({
      id: 'customCanvasBackgroundColor',
      beforeDraw: (chart, args, options) => {
        const {ctx} = chart;
        ctx.save();
        ctx.globalCompositeOperation = 'destination-over';
        ctx.fillStyle = '#ffffff';
        ctx.fillRect(0, 0, chart.width, chart.height);
        ctx.restore();
      }
    });

    // //Simple plugin for overlapping two axis
    Chart.register({
      id: 'overlap_x_axis',
      beforeDraw: function(chart) {
        if(chart.scales['x1'] && chart.scales['x']){
          chart.scales['x1']["bottom"] = chart.scales['x']["bottom"];
        }   
      }
    });



    // // Fill color for 100 db to 120 db
    Chart.register({
      id: 'fill_color',
      beforeDraw: function(chart :any) {
        const {ctx, scales: {x , y}} = chart;
        
        const startX = x.getProps().left;
        const startY = y.getPixelForValue(100);

        const endX = x.getProps().right;
        const endY = y.getPixelForValue(120);

        ctx.save();
        ctx.fillStyle ='#BFBFBF';
        ctx.fillRect(startX, startY, endX- startX, endY-startY);
    
      }
    });
  }


}
